<template>
	<div class="p4 xs-12">
		<!-- Language selector -->
		<div class="xs-4 mb4" v-if="$store.state.settings.allowedLocales">
			<div class="pr2 xs-12 fs4 lh125 fw7 pb1">{{ $t("language") }}</div>
			<core-select-locale class="xs-12" size="xsmall" v-model="form.locale" />
		</div>
		<core-form-input
			name="name"
			componentName="j-base-input-text"
			:label="$t('name')"
			v-validate="{ required: true }"
			:validationErrors="errors"
			v-model="form.name"
		/>
		<core-form-input
			class="mt6"
			name="description"
			componentName="j-base-input-long-text"
			:label="$t('description')"
			v-validate="{ required: true }"
			:validationErrors="errors"
			v-model="form.description"
		/>
		<core-form-input
			class="mt6"
			name="plan"
			componentName="j-base-input-text"
			:label="$t('plan')"
			v-validate="{ required: true }"
			:validationErrors="errors"
			v-model="form.plan"
		/>
		<core-form-input
			class="mt6"
			name="type"
			componentName="j-base-input-text"
			:label="$t('type')"
			v-validate="{ required: true }"
			:validationErrors="errors"
			v-model="form.type"
		/>
		<core-form-input
			class="mt6"
			name="version"
			componentName="j-base-input-text"
			:label="$t('version')"
			v-model="form.version"
		/>
		<slot :onSubmit="onSubmit"></slot>
	</div>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import CoreSelectLocale from "@/modules/core/components/CoreSelectLocale"

import { i18n } from "@/locales/setup.js"

export default {
	components: { CoreFormInput, CoreSelectLocale },

	data() {
		return {
			form: {
				locale: i18n.locale,
				name: null,
				description: null,
				plan: null,
				type: null,
				version: null
			}
		}
	},

	methods: {
		async onSubmit() {
			const isValid = await this.$validator.validate()
			if (!isValid) return
			this.$emit("submit", this.form)
		}
	}
}
</script>

<style></style>
